import React, { SVGProps } from 'react'

const Sparkle: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" role="img" {...props}>
    <path
      d="M11.9821 1.08929C11.9821 1.08929 12.133 2.21226 12.5705 2.67945C13.0405 3.18123 14.1607 3.26787 14.1607 3.26787C14.1607 3.26787 13.0405 3.35451 12.5705 3.85628C12.133 4.32347 11.9821 5.44644 11.9821 5.44644C11.9821 5.44644 11.8313 4.32347 11.3937 3.85628C10.9238 3.35451 9.80356 3.26787 9.80356 3.26787C9.80356 3.26787 10.9238 3.18123 11.3937 2.67945C11.8313 2.21226 11.9821 1.08929 11.9821 1.08929Z"
      fill="#722ED1"
    />
    <path
      d="M3.26787 9.80356C3.26787 9.80356 3.41874 10.9265 3.85628 11.3937C4.3262 11.8955 5.44644 11.9821 5.44644 11.9821C5.44644 11.9821 4.3262 12.0688 3.85628 12.5705C3.41874 13.0377 3.26787 14.1607 3.26787 14.1607C3.26787 14.1607 3.11699 13.0377 2.67945 12.5705C2.20953 12.0688 1.08929 11.9821 1.08929 11.9821C1.08929 11.9821 2.20953 11.8955 2.67945 11.3937C3.11699 10.9265 3.26787 9.80356 3.26787 9.80356Z"
      fill="#722ED1"
    />
    <path
      d="M7.625 0C7.625 0 8.15308 3.93039 9.68444 5.56556C11.3292 7.32176 15.25 7.625 15.25 7.625C15.25 7.625 11.3292 7.92824 9.68444 9.68444C8.15308 11.3196 7.625 15.25 7.625 15.25C7.625 15.25 7.09692 11.3196 5.56556 9.68444C3.92084 7.92824 0 7.625 0 7.625C0 7.625 3.92084 7.32176 5.56556 5.56556C7.09692 3.93039 7.625 0 7.625 0Z"
      fill="#722ED1"
    />
  </svg>
)

export default Sparkle
